import axios from "axios";
import AppConfig from "./global";

const http = axios.create({
   baseURL: AppConfig.baseUrl,
   headers: {
      "Content-type": "application/json",
   },
});

const http2 = axios.create({
   baseURL: AppConfig.baseUrlSecondary,
   headers: {
      "Content-type": "application/json",
   },
});

export { http, http2 };
